import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
  Image,
} from 'react-bootstrap'
import Swal from 'sweetalert2'
import 'bootstrap/dist/css/bootstrap.min.css'

const Setting = () => {
  const [profileSettings, setProfileSettings] = useState({
    bio: '',
    tagline: '',
    profile_pic: '',
    social_links: [],
  })

  const [profilePreview, setProfilePreview] = useState('')
  const [showAlert, setShowAlert] = useState(false)
  const fileInputRef = useRef(null)
  const [show, setShow] = useState(true)

  const token = localStorage.getItem('jwttoken')

  useEffect(() => {
    if (show) {
      axios
        .get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const userData = response.data
          setProfileSettings({
            bio: userData.bio || '',
            tagline: userData.tagline || '',
            profile_pic: userData.profile_pic || '',
            social_links: userData.social_links || [],
          })
          setProfilePreview(userData.profile_pic || '')
        })
        .catch((reason) => {
          console.error('Failed to fetch user data:', reason)
          Swal.fire({
            icon: 'error',
            title: 'Failed to Load Data',
            text: 'There was an error loading your profile data.',
            confirmButtonText: 'OK',
          })
        })
    }
  }, [show])

  const handleChange = (e) => {
    setProfileSettings({
      ...profileSettings,
      [e.target.name]: e.target.value,
    })
  }

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setProfilePreview(reader.result)
        setProfileSettings({ ...profileSettings, profile_pic: reader.result })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleSave = (e) => {
    e.preventDefault()
    axios
      .patch('https://kaasbackend.vetrinahealthcare.com/lms/user/', profileSettings, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response.data)
        Swal.fire({
          icon: 'success',
          title: 'Profile Updated',
          text: 'Your profile details have been successfully updated!',
          confirmButtonText: 'OK',
        })
        setShow(false)
      })
      .catch((reason) => {
        console.error('Failed to update profile:', reason)
        Swal.fire({
          icon: 'error',
          title: 'Failed to Update Profile',
          text: 'There was an error updating your profile. Please try again.',
          confirmButtonText: 'OK',
        })
      })
  }

  return (
    <Container className='mt-5'>
      <h1 className='mb-4'>KAAS LMS Settings</h1>
      <Form onSubmit={handleSave}>
        <Row>
          <Col md={4}>
            <Card className='mb-4'>
              <Card.Body>
                <div className='text-center mb-3'>
                  <Image
                    src={
                      profilePreview 
                    }
                    roundedCircle
                    width={150}
                    height={150}
                    alt='Profile'
                    className='mb-3'
                  />
                  <div>
                    <Button
                      variant='outline-primary'
                      onClick={() => fileInputRef.current?.click()}
                    >
                      Change Picture
                    </Button>
                    <Form.Control
                      type='file'
                      ref={fileInputRef}
                      className='d-none'
                      onChange={handleProfilePicChange}
                      accept='image/*'
                    />
                  </div>
                </div>
                <Form.Group className='mb-3'>
                  <Form.Label>Bio</Form.Label>
                  <Form.Control
                    as='textarea'
                    name='bio'
                    value={profileSettings.bio}
                    onChange={handleChange}
                    rows={3}
                  />
                </Form.Group>
                <Form.Group className='mb-3'>
                  <Form.Label>Tagline</Form.Label>
                  <Form.Control
                    type='text'
                    name='tagline'
                    value={profileSettings.tagline}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
          <Col md={8}>
            <Card className='mb-4'>
              <Card.Header>Social Links</Card.Header>
              <Card.Body>
                {profileSettings.social_links.map((link, index) => (
                  <Form.Group key={index} className='mb-3'>
                    <Form.Label>Link {index + 1}</Form.Label>
                    <Form.Control
                      type='url'
                      value={link}
                      onChange={(e) => {
                        const newLinks = [...profileSettings.social_links]
                        newLinks[index] = e.target.value
                        setProfileSettings({
                          ...profileSettings,
                          social_links: newLinks,
                        })
                      }}
                    />
                  </Form.Group>
                ))}
                <Button
                  variant='outline-secondary'
                  onClick={() =>
                    setProfileSettings({
                      ...profileSettings,
                      social_links: [...profileSettings.social_links, ''],
                    })
                  }
                >
                  Add Link
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Button type='submit' variant='primary' size='lg'>
          Save Settings
        </Button>
      </Form>
    </Container>
  )
}

export default Setting
